module.exports = __webpack_public_path__ + "static/media/testfile_shadowDetection.fc33567d.zip";